module.exports = __webpack_public_path__ + "static/media/19.fd206316.jpg";